import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Apply branding from REACT_APP_* env vars at app startup (build-time values)
function applyBranding() {
  try {
    const title = process.env.REACT_APP_SITE_TITLE;
    if (title) document.title = title;

    // favicon
    const faviconUrl = process.env.REACT_APP_FAVICON_URL || process.env.REACT_APP_FAVICON || `${process.env.PUBLIC_URL || ''}/favicon.ico`;
    if (faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = faviconUrl;
    }

    // theme-color meta
    const themeColor = process.env.REACT_APP_THEME_COLOR;
    if (themeColor) {
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) meta.setAttribute('content', themeColor);
    }

    // CSS variables for colors and fonts
    const rootStyle = document.documentElement.style;
    rootStyle.setProperty('--primary-color', process.env.REACT_APP_PRIMARY_COLOR || '#2563eb');
    rootStyle.setProperty('--secondary-color', process.env.REACT_APP_SECONDARY_COLOR || '#64748b');
    rootStyle.setProperty('--accent-color', process.env.REACT_APP_ACCENT_COLOR || '#3b82f6');
    rootStyle.setProperty('--background-color', process.env.REACT_APP_BACKGROUND_COLOR || '#ffffff');
    rootStyle.setProperty('--font-family', process.env.REACT_APP_FONT_FAMILY || 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial');
    rootStyle.setProperty('--focus-color', process.env.REACT_APP_FOCUS_COLOR || '#3b82f6');

    // Expose some branding values for components if needed
    window.__BRANDING__ = {
      logoUrl: process.env.REACT_APP_LOGO_URL || null,
      footerText: process.env.REACT_APP_FOOTER_TEXT || ''
    };
  } catch (e) {
    // safe fail
    // eslint-disable-next-line no-console
    console.debug('applyBranding error', e);
  }
}

applyBranding();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
